import me from "models/me";
import type { IScope } from "reducers/scope";

/**
 * Check if the user is an unconnected buyer from the marketplace
 * @param scope - The scope
 * @param flags - The LD flags
 * @returns Boolean
 */
export const isAnUnconnectedBuyerFromMarketplace = (scope: IScope, flags?: Flags) =>
    (flags ? isRestrictedUser(flags) : true) && me?.account_type === "buyer" && scope?.brand?.__virtualConnection;

type Flags = Record<string, unknown>;
const isRestrictedUser = (flags: Flags) => flags?.marketplaceAccessNu70087 && me?.marketplace_access;
